import Icon from '../components/Icon.vue'

Icon.register({
  magic: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M224 96l-16-32-32-16 32-16 16-32 16 32 32 16-32 16zM80 160l-26.7-53.3-53.3-26.7 53.3-26.7 26.7-53.3 26.7 53.3 53.3 26.7-53.3 26.7zM432 288l26.7 53.3 53.3 26.7-53.3 26.7-26.7 53.3-26.7-53.3-53.3-26.7 53.3-26.7zM502.6 94.2c12.5 12.5 12.5 32.8 0 45.2l-363.1 363.1c-6.3 6.3-14.4 9.4-22.6 9.4-8.2 0-16.4-3.1-22.6-9.4l-84.9-84.9c-12.5-12.5-12.5-32.8 0-45.3l363.1-363.1c6.3-6.3 14.4-9.4 22.6-9.4 8.2 0 16.4 3.1 22.6 9.4zM359.4 203.5l86.6-86.6-50.9-50.9-86.6 86.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/magic.js
// module id = 1538
// module chunks = 0